import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const KebabMenuElement = styled.div<{ imgBgColor?: string }>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: ${COLORS.ButtonSecondary};
    border-radius: 50%;
`;
